import { Workbox } from 'workbox-window'
import { envMode, envModes } from '$config/env'
import { showNewUpdateIsAvailableSnackbar } from '$comp/snackbars'
import { VERSION } from '$setup/version'
import { fullReload } from '$func/fullReload'

let isForceUpdate = false
let shouldShowAlert = false
export const setIsForcedUpdate = forced => {
  shouldShowAlert = true
  isForceUpdate = forced
}

if ('serviceWorker' in navigator && envMode === envModes.PRODUCTION) {
  const wb = new Workbox('/sw.js')

  wb.addEventListener('waiting', () => {
    // Set up a listener that will reload the page as soon as the previously waiting service worker has taken control.
    wb.addEventListener('controlling', async (...a) => {
      // should perform different action based in isForceUpdate
      // if (shouldShowAlert)
      const newVersion = await wb.messageSW({ type: 'GET_VERSION' })

      if (newVersion.version !== VERSION)
        showNewUpdateIsAvailableSnackbar(fullReload)
    })

    // This will postMessage() to the waiting service worker.
    wb.messageSkipWaiting()
  })

  // Register the service worker after event listeners have been added.
  wb.register()
}
